import authRules from '../authRules.js';

const editTour = (user) => {
  const { tour } = user.securityLevels;
  if (tour >= authRules.editTour.tour) {
      return true;
  } else {
      return false;
    }
  }


export default editTour;
